import menuItemsProps from '../interfaces/MenuItemProps';

const checkItemName = (itemsList: Array<menuItemsProps>, itemName: string) => {
  let currentItem: any = []
  if (itemsList.length) {
    currentItem = itemsList.find(itemEl => itemEl.item_name.toLowerCase() === itemName);
  };
  return currentItem;
};

export default checkItemName;